// extracted by mini-css-extract-plugin
module.exports = {"Emptyconet":"mainemptyConet_Emptyconet__2wicY"};